import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button,Grid } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { Link,useHistory } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons=false }) => {
  const history = useHistory();

  const handleLogout =() =>{
    localStorage.clear();
    history.push('/');
    window.location.reload();
  };
   
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        <Grid >
        {children}
        </Grid>
        {hasHiddenAuthButtons ? <Link className="link" to="/"> 
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
        >
         Back to explore
        </Button></Link>:<>
          {
            localStorage.getItem('token') ? <div style={{display:'flex'}}>
              <div style={{display:'flex',alignItems:'center',marginRight:'1em'}}>
              <Avatar src="public/avatar.png" alt={localStorage.getItem('username')}/>
              <p style={{marginLeft:'0.5em',marginBottom:'0rem'}}>{localStorage.getItem('username')}</p>
              </div>
              <Button onClick={handleLogout}>LOGOUT</Button>
            </div>:<div>
            <Link className="link" to="/login">
             <Button name="login">LOGIN</Button>
            </Link>
            <Link className="link" style={{color:'#ffff'}} to="/register">
             <Button name="register" variant="contained">REGISTER</Button>
            </Link>
            </div>
          }
          </>}
      </Box>
    );
};

export default Header;
